import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact from 'single-spa-react';

import { ErrorPage } from '@soluto-private/mx-asurion-ui-react';

import {
  GlobalNormalizeCss,
  GlobalResetCss,
} from '@service-initiation/tech-care-ui-styles';

import { App } from './app/App';
const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  errorBoundary(error, _info, _props) {
    return <ErrorPage />;
  },
  rootComponent: () => (
    <StrictMode>
      <GlobalNormalizeCss />
      <GlobalResetCss />
      <App />
    </StrictMode>
  ),
});

export const { bootstrap, mount, unmount } = lifecycles;
